import { Form, FormInstance, Radio, Space } from 'antd';
import { DataFeedFormField, DatasetLabels } from './DataFeedForm';

export const datasetCanContinue = (form: FormInstance) =>
  !!form.getFieldValue(DataFeedFormField.dataset);

export const DatasetTabForm = () => {
  return (
    <Form.Item
      name={DataFeedFormField.dataset}
      label="Select a dataset"
      required
    >
      <Radio.Group>
        <Space direction="vertical">
          {Object.keys(DatasetLabels).map((key) => {
            return (
              <Radio key={key} value={key}>
                {DatasetLabels[key]}
              </Radio>
            );
          })}
        </Space>
      </Radio.Group>
    </Form.Item>
  );
};
